export default __webpack_public_path__ + "static/media/participateIcon2.47d04506.png";